type Listener = () => void;

// Single-slot listener: only the most recently registered TourProvider can
// receive start requests. Prevents duplicate fires when multiple
// (app)/_layout instances are briefly mounted during route transitions.
let activeListener: Listener | null = null;
let pendingFire = false;
let lastFireAt = 0;
const FIRE_DEBOUNCE_MS = 800;

export function subscribeTourStartRequest(listener: Listener) {
  activeListener = listener;
  if (pendingFire) {
    pendingFire = false;
    listener();
  }
  return () => {
    if (activeListener === listener) {
      activeListener = null;
    }
  };
}

export function requestTourStart() {
  const now = Date.now();
  if (now - lastFireAt < FIRE_DEBOUNCE_MS) return;
  lastFireAt = now;
  if (activeListener) {
    activeListener();
  } else {
    pendingFire = true;
  }
}
